import React from 'react';
import Event from './EventItem.jsx';
import VolunteerItem from './VolunteerItem.jsx';
import './EventDisplay.css'

export default class EventsList extends React.PureComponent {
  render() {
    const {eventsAtTime, singleTeamView, time} = this.props;
    if (eventsAtTime === undefined) {
      return (<div className="loading-gif" />);
    };
    // The single leaf both the day panel and the future list render through, so
    // branching here covers both surfaces at once. Volunteer items go to
    // VolunteerItem because Event dereferences _links.self.href, which a
    // volunteer item omits when its sheet has no link team. Only
    // VolunteerCalendarItemDecorator emits event_type "volunteer".
    return (
      <div className="eventTimeBlock ">
        {eventsAtTime.map((event, idx) => event.event_type === 'volunteer' ?
          <VolunteerItem key={`volunteer-${time}-${idx}`} event={event} /> :
          <Event key={`event-${time}-${idx}`} time={time} singleTeamView={singleTeamView} event={event} />)}
      </div>
    );
  }
}
